import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  nameTitle: {
    id: 'donater.form.name.title',
    defaultMessage: 'Your Name',
  },
  namePlaceholder: {
    id: 'donater.form.name.placeholder',
    defaultMessage: 'Mick Jagger',
  },
  anonPlaceholder: {
    id: 'donater.form.name.anon_placeholder',
    defaultMessage: 'Anonymous',
  },
  remainAnon: {
    id: 'donater.form.remainAnon',
    defaultMessage: 'Remain anonymous',
  },
  required: {
    id: 'donater.form.required',
    defaultMessage: 'Name is required',
  },
})
